import React, { FunctionComponent, useEffect, useRef } from 'react'
import { Actions } from '../../../../contexts/app-state/AppStateReducer'
import Player from '@vimeo/player'
import { useAppState } from '../../../../contexts/app-state/AppStateContext'

interface VimeoProps {
  id: string
  title: string
}

const Vimeo: FunctionComponent<VimeoProps> = ({ id, title }) => {
  const ref = useRef<HTMLIFrameElement | null>(null)
  const [, dispatch] = useAppState()

  useEffect(() => {
    if (ref.current) {
      const player = new Player(ref.current)

      const onPlay = (): void => {
        dispatch({
          payload: false,
          type: Actions.SET_IS_AUDIO_TOUR_PLAYING,
        })
      }

      player.on('play', onPlay)

      return (): void => {
        player.off('play', onPlay)
      }
    }
  }, [ref.current])

  return (
    <iframe
      allow="autoplay; fullscreen"
      allowFullScreen
      frameBorder="0"
      height="360"
      ref={ref}
      src={`https://player.vimeo.com/video/${id}`}
      title={title}
      width="640"
    />
  )
}

export default Vimeo
